import {
	DocumentLibrarySchema,
	type DocumentLibraryEntry,
} from '#app/routes/mocra+/_form+/components/document-libraries/schema.ts'
import {
	collectDocumentLibraryErrors,
	createDocumentLibraryDraft,
	documentLibraryDraftToEntry,
	documentLibraryEntryToDraft,
	sanitizeDocumentLibraryDraft,
	type DocumentLibraryDraft,
} from '#app/routes/mocra+/_form+/components/document-libraries/types.ts'
import { assertEntityDefinition } from '#app/routes/mocra+/_form+/entity-definition.ts'

export const documentLibraryDefinition = assertEntityDefinition<
	DocumentLibraryEntry,
	DocumentLibraryDraft
>({
	schema: DocumentLibrarySchema,
	createDraft: () => createDocumentLibraryDraft(),
	sanitizeDraft: sanitizeDocumentLibraryDraft,
	serialize: documentLibraryDraftToEntry,
	deserialize: documentLibraryEntryToDraft,
	collectErrors: collectDocumentLibraryErrors,
})

export type DocumentLibraryEntityDraft = DocumentLibraryDraft
